// The single source of the product name and brand values. Fable owns the name in
// docs/NAME.md (decision 2026-10-21: "Sidetone"). Change it here and nowhere else;
// the desktop shell, window titles and notifications read these values.
export const APP_NAME = 'Sidetone';
export const APP_SHORT_NAME = 'Sidetone';
export const APP_TAGLINE = 'The phone system that lets a team hear itself';
export const APP_NAME_SOURCE = 'docs/NAME.md, decided 2026-10-21';
export const APP_OWNER = 'Brandcore';

/** Brand anchors from the UX spec (section 3.2, "Paper and Line"). The full token set lives in styles/tokens.css. */
export const BRAND_TOKENS = {
  brassFill: '#C9A230',
  brassDay: '#775508',
  brassNight: '#DDBB5E',
  inkDay: '#1A1D1F',
  inkNight: '#ECE9E2',
  canvasDay: '#F3F1EC',
  canvasNight: '#15171A',
  lineDay: '#181A1D',
  lineNight: '#0F1113',
} as const;

/**
 * F5's finished identity artwork (apps/web/public/brand, see docs/archive/2026-10/implementation/F5-LOGO-REPORT.md
 * and assets/brand/DESIGN.md). Used as files, never redrawn. `day` is ink, `night` the reverse.
 * Sizes follow DESIGN.md: 32 px pixel-fitted mark on the 80 px rail; compact lockup 24 px tall in
 * the 216 px rail and 20 px (its minimum) in the top bar; display lockup 32 px on sign-in.
 */
export const BRAND_ASSETS = {
  mark32: { day: '/brand/sidetone-mark-32px.svg', night: '/brand/sidetone-mark-32px-reverse.svg', width: 32, height: 32 },
  lockupCompact: { day: '/brand/sidetone-lockup-compact.svg', night: '/brand/sidetone-lockup-compact-reverse.svg', width: 660.18, height: 132 },
  lockup: { day: '/brand/sidetone-lockup.svg', night: '/brand/sidetone-lockup-reverse.svg', width: 641.77, height: 132 },
} as const;

/** Web app manifest and icons (F5). Colours from DESIGN.md: graphite #15171A. */
export const BRAND_ICONS = {
  favicon: '/brand/favicon.ico',
  faviconSvg: '/brand/favicon.svg',
  appleTouch: '/brand/apple-touch-icon.png',
  manifestIcons: [
    { src: '/brand/icon-192.png', sizes: '192x192', type: 'image/png', purpose: 'any' },
    { src: '/brand/icon-512.png', sizes: '512x512', type: 'image/png', purpose: 'any' },
    { src: '/brand/icon-maskable-192.png', sizes: '192x192', type: 'image/png', purpose: 'maskable' },
    { src: '/brand/icon-maskable-512.png', sizes: '512x512', type: 'image/png', purpose: 'maskable' },
  ],
  backgroundColor: '#15171A',
  themeColor: '#15171A',
} as const;

/** "Inbox | Sidetone"; during a call "On call 4:12 | Sidetone". */
export function windowTitle(section: string | null): string {
  return section ? `${section} | ${APP_NAME}` : APP_NAME;
}

if (!APP_NAME.trim()) {
  throw new Error('APP_NAME must be set in src/config/brand.ts');
}
